const currencyMap: Record<string, string> = {
  AUD: '$',
  EUR: '€',
  GBP: '£',
}
export const getSymbolForCurrency = (currency?: string) => {
  return currency ? currencyMap[currency] : currencyMap.GBP
}
